import { ControlDelivery } from "../../../../types/delivery/control-delivery";
import { getIsDuplicated } from "../../../../utils/delivery/control-delivery";
import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveries: ControlDelivery[];
  };
}

export const initControlDeliveriesDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveries } = action.payload;
  state.controlDeliveries = [];

  for (const delivery of deliveries) {
    const isDuplicated = getIsDuplicated(state.controlDeliveries, delivery);
    if (!isDuplicated) {
      state.controlDeliveries.push(delivery);
    }
  }
};
